import axios from "axios";
import { ROOT_SERVER } from "../utilities/Static";
import { isDesignerViewer } from "./AuthState";

export default function MaterialViewCount(id, userInformation) {
  if (!id || !isDesignerViewer(userInformation)) {
    return;
  }

  let viewed = [];
  try {
    const raw = localStorage.getItem("viewedMats");
    viewed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(viewed)) {
      viewed = [];
    }
  } catch {
    viewed = [];
  }

  if (viewed.includes(id)) {
    return;
  }

  localStorage.setItem("viewedMats", JSON.stringify([...viewed, id]));
  Promise.resolve(
    axios.put(`${ROOT_SERVER}material/view_count/${id}/add`),
  ).catch(() => {});
}
